/**
 * Folds text for search-as-you-type: lower case, no diacritics (including ł, which
 * Unicode does not decompose), single spaces. "Żółkiewski  Łukasz" → "zolkiewski lukasz".
 */
export function foldForSearch(input: string): string {
  return input
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/ł/g, 'l')
    .replace(/Ł/g, 'L')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}

/** Escapes `%`, `_` and `\` for use inside a SQL LIKE pattern. */
export function escapeLike(input: string): string {
  return input.replace(/[\\%_]/g, (c) => `\\${c}`);
}

/**
 * Polish plural forms: plural(1, 'wizyta', 'wizyty', 'wizyt') → "1 wizyta",
 * 3 → "3 wizyty", 5 → "5 wizyt", 12 → "12 wizyt", 22 → "22 wizyty".
 */
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n);
  const lastTwo = abs % 100;
  const last = abs % 10;
  let word: string;
  if (abs === 1) word = one;
  else if (last >= 2 && last <= 4 && (lastTwo < 12 || lastTwo > 14)) word = few;
  else word = many;
  return `${n} ${word}`;
}
